import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-triangledown",
  "use": "icon-triangledown-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-triangledown\"><path fill=\"#333333\" d=\"M94.8 304.5L512 721.8l416-416-833.2-1.3z m0 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol